import {
    type ViewStyle,
    StyleSheet,
    Platform
} from "react-native";
import type {
    DirectionProviderStyleConstantType,
    DirectionProviderDynamicStyleType
} from "./type";

export const getDirectionProviderDirection = ({
    direction
}: DirectionProviderStyleConstantType): ViewStyle => {
    if(Platform.OS === "web" || !direction) {
        return {};
    }

    return {
        direction
    };
};

const stylesheet = StyleSheet.create({});

export const useStyles = ({
    direction
}: DirectionProviderDynamicStyleType) => {
    return {
        container: getDirectionProviderDirection({
            direction
        })
    };
};
export default stylesheet;
